// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { FormTokens } from './type';

const formTokens: FormTokens = {
  formItemFontSize: '14/regular',
  formItemFontColor: 'Neutral-text-5',
  formItemMarginYEnd: 'Margin-12',
  formItemMarginXEnd: 'Margin-16',
  formItemLabelWidth: '140px',
  formItemLabelPaddingY: 'Padding-5',
  formItemLabelMarginXEnd: 'Margin-8',
  formItemDangerColor: 'Danger-6',
  formItemTipMinHeight: '20px',
  formItemTipFontSize: '12/regular',
  formItemTipFontColor: 'Neutral-text-3',
};

export default formTokens;
